import styled from '@emotion/native';
import type { ColorName } from '@emotion/react';
import { Icon } from 'design-system/base';
import type { PropsWithChildren } from 'react';
import { Pressable } from 'react-native';

interface CheckboxProps {
  checked?: boolean;
  onChange?: () => void;
  color?: ColorName;
  size?: number;
  disabled?: boolean;
  iconColor?: ColorName;
  iconSize?: number;
}

export const Checkbox = styled.View<PropsWithChildren<CheckboxProps>>(
  ({
    checked = false,
    color = 'primary',
    size = 20,
    disabled = false,
    theme,
  }) => {
    const checkboxColor = theme.color[color] || color;
    const disabledColor = theme.color['text-disabled'];

    return {
      width: size,
      height: size,
      borderRadius: 4,
      backgroundColor: checked ? checkboxColor : 'transparent',
      borderWidth: 2,
      borderColor: checked ? checkboxColor : theme.color['divider'],
      opacity: disabled ? 0.6 : 1,
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      ...(disabled && {
        backgroundColor: checked ? disabledColor : 'transparent',
        borderColor: disabledColor,
      }),
    };
  },
);

export const CheckboxWithIcon: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  size = 20,
  iconColor = 'white',
  iconSize,
  ...props
}) => {
  return (
    <Pressable onPress={onChange}>
      <Checkbox checked={checked} size={size} {...props}>
        {checked && (
          <Icon
            name="check"
            color={iconColor}
            size={iconSize || Math.floor(size * 0.7)}
          />
        )}
      </Checkbox>
    </Pressable>
  );
};
